import { CircularProgress } from "@material-ui/core";
import moment from "moment";
import { useContext, useEffect, useMemo, useState } from "react";
import { MdDownload } from "react-icons/md";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import TabPanel from "../../../ReusableComponents/TabPanel";
import ProcessDashboard from "./ProcessDashboard";
import { usePreferences } from "../../../../contexts/PreferencesContext";
import { DashboardContext } from "..";
import "../../../Processo/label.css";
import "../../label.css";

const Cards = () => {
  const { t } = usePreferences();
  const history = useHistory();
  const location = useLocation();
  const user = useSelector(state => state.AppReducer.user);
  const dashboard = useContext(DashboardContext);
  const [activeTab, setActiveTab] = useState(-1);

  const data = useMemo(() => dashboard || {}, [dashboard]);
  const faculdade = data.faculdade || {};
  const processos = data.processos || [];
  const changedText = user?.empresa?.change_text === true;

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const processoId = params.get("processo_id");
    const tab = params.get("tab");

    if (processos.length > 0 && processoId != null) {
      const processIndex = processos.findIndex(item => String(item.id) === String(processoId));
      setActiveTab(processIndex >= 0 ? processIndex : -1);
      return;
    }

    setActiveTab(tab != null && !Number.isNaN(parseInt(tab)) ? parseInt(tab) : -1);
  }, [location.search, processos]);

  const dashboardTotals = [
    {
      icon: "📋",
      label: changedText ? t("legacy_vagas") : t("title_process"),
      value: processos.length
    },
    {
      icon: "👥",
      label: t("candidates"),
      value: data.alunos || 0,
      link: `/instituicao/show/${faculdade.id}?tab=4`,
      action: t("ui_gerenciar_candidatos_a4e149c2")
    },
    {
      icon: "👨‍🏫",
      label: t("graders"),
      value: data.corretores || 0,
      link: `/instituicao/show/${faculdade.id}?tab=1`,
      action: t("action_manage_graders")
    },
    {
      icon: "🛡️",
      label: t("proctors"),
      value: data.fiscais || 0,
      link: `/instituicao/show/${faculdade.id}?tab=2`,
      action: t("action_manage_proctors")
    },
    {
      icon: "⭐",
      label: t("evaluators"),
      value: data.avaliadores?.length || 0,
      link: `/instituicao/show/${faculdade.id}?tab=3`,
      action: t("action_manage_evaluators")
    }
  ];

  if (data.isLoading) {
    return (
      <div className="dashboard-panel">
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 240 }}>
          <CircularProgress />
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="process-breadcrumb">
        <Link to="/">
          {changedText ? t("title_process") : t("title_institution")}
        </Link>
        <span>›</span>
        <strong>{faculdade.name}</strong>
        <span>›</span>
        <strong>{t("dashboard")}</strong>
      </div>

      <div className="institution-hero-card">
        <div className="institution-hero-left">
          <div
            className="institution-logo"
            style={{
              backgroundImage: faculdade.logo ? `url(${faculdade.logo})` : undefined,
              backgroundSize: "contain"
            }}
          />

          <div className="institution-content">
            <h1>{faculdade.name}</h1>
            <p>
              {changedText ? t("desc_process_dashboard_data") : t("desc_institution_dashboard_data")}
            </p>
            <div className="institution-meta">
              {faculdade.created_at && (
                <div className="meta-item">
                  📅
                  <span>{t("label_created_at_feminine")} {moment(faculdade.created_at).format("DD/MM/YYYY")}</span>
                </div>
              )}
              {user?.name && (
                <div className="meta-item">
                  👤
                  <span>{t("ui_responsavel_dac53a5e")} {user.name}</span>
                </div>
              )}
            </div>
          </div>
        </div>

        <Link to={`/instituicao/show/${faculdade.id}`} className="btn-back-modern">
          {t("action_manage_dashboard")}
        </Link>
      </div>

      <div className="summary-container">
        <div className="summary-left">
          <h3>{t("title_quick_summary")}</h3>
          <div className="summary-cards">
            {dashboardTotals.map(item => (
              <div className="summary-card" key={item.label}>
                <div className="summary-icon blue">{item.icon}</div>
                <div className="summary-number">{item.value}</div>
                <div className="summary-label">{item.label}</div>
                {item.link && (
                  <Link to={item.link} className="summary-link">
                    {item.action}
                  </Link>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="summary-right">
          <h3>{t("title_realtime_indicators")}</h3>
          <div className="activity-list">
            <div className="activity-item">
              <div className="activity-dot" />
              <span>{t("legacy_candidatos_online")}: {data.alunos_online?.length || 0}</span>
            </div>
            <div className="activity-item">
              <div className="activity-dot" />
              <span>{t("legacy_fiscais_online")}: {data.fiscais_online?.length || 0}</span>
            </div>
            <div className="activity-item">
              <div className="activity-dot" />
              <span>{t("legacy_avaliadores_online")}: {data.avaliadores?.length || 0}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="institution-dashboard-section">
        <div className="dashboard-panel dashboard-process-panel">
          <div className="dashboard-panel-header">
            <div>
              <h3>{t("legacy_relatorios_por_vaga_cargo")}</h3>
              <p>{t("chooseProcessReports")}</p>
            </div>
          </div>

          <div className="dashboard-process-tabs">
            <button
              type="button"
              className={activeTab === -1 ? "active" : ""}
              onClick={() => {
                setActiveTab(-1);
                history.push({ search: "" });
              }}
            >
              {t("title_quick_summary")}
            </button>
            {processos.map((processo, index) => (
              <button
                type="button"
                key={processo.id}
                className={activeTab === index ? "active" : ""}
                onClick={() => {
                  setActiveTab(index);
                  history.push({ search: `?tab=${index}` });
                }}
              >
                {processo.name}
              </button>
            ))}
          </div>

          {activeTab === -1 && (
            <div className="report-actions-grid">
              {user?.empresa?.online_proccess === true && (
                <Link className="report-action-card" to={`/instituicao/show/${faculdade.id}?tab=5`}>
                  <span className="report-action-icon"><MdDownload /></span>
                  <strong>{t("legacy_relatorios_gerais")}</strong>
                  <small>{t("legacy_abrir_modulo")}</small>
                </Link>
              )}
              <Link className="report-action-card" to={`/instituicao/show/${faculdade.id}`}>
                <span className="report-action-icon">📋</span>
                <strong>{changedText ? t("legacy_vagas") : t("title_process")}</strong>
                <small>{t("title_choose_module_manage")}</small>
              </Link>
            </div>
          )}

          {processos.map((processo, index) => (
            activeTab === index && (
              <TabPanel key={processo.id} value={activeTab} index={index}>
                <div className="dashboard-process-content">
                  <ProcessDashboard processo_id={processo.id} />
                </div>
              </TabPanel>
            )
          ))}
        </div>
      </div>
    </div>
  );
};

export default Cards;
